
import { useRef } from 'react';
import { FormInput } from '../styles';

type InputProps = {
  type?: string,
  name?: string,
  id?: string,
  autoComplete?: string,
  value?: string,
  maxLength?: number,
  minLength?: number,
  required?: boolean,
  className?: string,
  handleChange: (value: string) => void,
};

const Input = ({
  type,
  name,
  id,
  autoComplete,
  value,
  maxLength,
  minLength,
  required,
  className,
  handleChange
}: InputProps) => {
  const TEXT_INPUT: React.MutableRefObject<any> = useRef(null);

  const onBlur = () => {
    let currentValue = TEXT_INPUT.current.value;

    if (typeof currentValue === 'string' && currentValue !== currentValue.trim()) { // if input has type "email" UI doesn't render it correctly, but send correct data when submit (https://github.com/facebook/react/issues/14897)
      currentValue = currentValue.trim();
      handleChange(currentValue);
    }
  };

  return (
    <FormInput
      type={type}
      name={name}
      id={id}
      autoComplete={autoComplete}
      value={value}
      required={required}
      maxLength={maxLength}
      minLength={minLength}
      className={className}
      onChange={(e) => handleChange(e.target.value)}
      onBlur={onBlur}
      ref={TEXT_INPUT}
    />
  );
};

export default Input;
